import { useEffect, useState, useRef } from "react";
import { createApplicationProcessCarousel } from "../Carousels";
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import { Props_SnippetApplicationProcess } from "./ApplicationProcess.props";

const SnippetApplicationProcess = (props: Props_SnippetApplicationProcess) => {
    const { heading, repeatable_stepprops } = props;
    const [activeIndex, setActiveIndex] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Pass the ref instead of the HTMLElement
        createApplicationProcessCarousel(containerRef, setActiveIndex);
    }, []);

    return (
        <section className="snippet-application-process">
            <div className="snippet-application-process__container" ref={containerRef}>
                <div className="snippet-application-process__heading-container">
                    <h2 className="snippet-application-process__heading">{heading.content?.value}</h2>
                </div>
                <div className="snippet-application-process__content-container">
                    {repeatable_stepprops.map((item, index) => (
                        <div key={index} className="snippet-application-process__item">
                            <div className="snippet-application-process__step">{item.step?.value}</div>

                            <figure className="snippet-application-process__image-container">
                                <img
                                    src={item.stepImage?.value}
                                    loading="lazy"
                                    height="100"
                                    width="100"
                                    alt="step icon"
                                    className="snippet-application-process__image" />
                            </figure>

                        </div>
                    ))}
                </div>
                <div className="snippet-application-process__body-container">
                    {repeatable_stepprops.map((item, index) => (
                        index === activeIndex && (
                            <div key={index} className="snippet-application-process__body">
                                <div className="snippet-application-process__text">
                                    {CompileMarkdown(item.content?.value || '')}
                                </div>
                            </div>
                        )
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetApplicationProcess;